"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pino = void 0;
const tslib_1 = require("tslib");
const pino_1 = tslib_1.__importDefault(require("pino"));
Object.defineProperty(exports, "pino", { enumerable: true, get: function () { return pino_1.default; } });
tslib_1.__exportStar(require("./constants"), exports);
tslib_1.__exportStar(require("./utils"), exports);
//# sourceMappingURL=index.js.map